module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/v2.1.1-rc.14-80.vue");


//////////////////
// WEBPACK FOOTER
// ./en/changelog/v2.1.1-rc.14.md
// module id = 497
// module chunks = 350